import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// import { MenuDropdown, MenuItem } from '@features/events/common';
import { ArrowDown } from '@shared/assets';
import { Textarea, useCommonMenu } from '@shared/ui';
import * as st from './styles.module.scss';

/*
  Пока нет внутреннего сервиса, по умолчанию стороний
**/

type Online = /*'Встроенный видеосервис' | */ 'Сторонний видеосервис';

// const reverseOnline = (online: Online): Online =>
//   online === 'Встроенный видеосервис' ? 'Сторонний видеосервис' : 'Встроенный видеосервис';

export const Online = (): JSX.Element => {
  const {
    control,
    register,
    formState: { errors },
    getValues,
  } = useFormContext();
  const { /*onClose,*/ onOpen, /* popperEl, referenceEl, setPopperEl,*/ setReferenceEl } =
    useCommonMenu();
  // const initialOnlineValue = getValues('external_service');
  const [dropdownValue, setDropdownValue] = useState<Online>('Сторонний видеосервис');

  return (
    <Controller
      name="external_service"
      control={control}
      render={({ field: { onChange, value } }) => (
        <div className={st.online}>
          <div className={st.online__switch} onClick={onOpen} ref={setReferenceEl}>
            Сторонний видеосервис
            <div className={st.online__icon}>
              <ArrowDown />
            </div>
          </div>
          {/* <MenuDropdown popperEl={popperEl} referenceEl={referenceEl} setPopperEl={setPopperEl}>
            <MenuItem
              onClick={(e) => {
                onClose(e);
                setDropdownValue(reverseOnline(dropdownValue));
                if (dropdownValue === 'Встроенный видеосервис') {
                  onChange('');
                }
              }}
              className={st.online__item}
            >
              {reverseOnline(dropdownValue)}
            </MenuItem>
          </MenuDropdown> */}
          {dropdownValue === 'Сторонний видеосервис' && (
            <div className={st.online__textarea}>
              <Textarea
                label="Ссылка на встречу"
                {...register(`external_service`)}
                defaultValue={value}
                required={!!errors.external_service}
              />
            </div>
          )}
        </div>
      )}
    />
  );
};
